// extracted by mini-css-extract-plugin
export default {"pageLayout":"ca-z","mainContent":"da-z","columnLayout":"ea-z","columnLayoutFill":"fa-z","columnLayoutLast":"ga-z"};